import { atomWithReset } from 'jotai/utils'

interface PartialMailPatientModalState {
  onSubmit: (createPatient: boolean) => void
}

export const partialMailPatientModalAtom = atomWithReset<PartialMailPatientModalState | null>(null)
